import React from "react";

export default function PictureSources({srcSetPrefix, sources, isFetchpriority} = {}) {
  return sources
    .map(({srcSetSuffix, media, type, srcSet}, index) => (
      <source key={index}
              srcSet={srcSet || `${srcSetPrefix}${srcSetSuffix}`}
              fetchPriority={isFetchpriority ? "high" : "auto"}
              type={type}
              media={media}
      />));
}
